import EventHandler from './dom/event-handler';
import SelectorEngine from './dom/selector-engine';
import LoadJS from './dom/loadjs';

class MapGen {
    /**
     * @param {HTMLElement} mapElem
     */
    constructor (mapElem) {
        /** @type {HTMLElement} */
        this.mapElem = mapElem;

        switch (mapElem.dataset.omeMaptype) {
            case "openstreetmap":
                LoadJS.load(mapElem.dataset.omeBaseurl + "/Resources/Public/JavaScript/leaflet.min.js")
                    .then(() => LoadJS.load(mapElem.dataset.omeBaseurl + "/Resources/Public/JavaScript/leaflet-tilelayer-colorfilter.min.js"))
                    .then(() => this.initOSM());
                break;
            case "googlemaps":
                window.initGMaps = this.initGMaps.bind(this);
                LoadJS.load("https://maps.googleapis.com/maps/api/js?key=" + mapElem.dataset.omeGoogleapi + "&callback=initGMaps");
                break;
        }
    }

    initOSM() {
        const mapCenterAndMarker = [
            parseFloat(this.mapElem.dataset.omeMaplat),
            parseFloat(this.mapElem.dataset.omeMaplong)
        ];
        const tileFilter = [
            'brightness: 60%',
            'invert: 100%',
            'contrast: 300%',
            'hue: 200deg',
            'saturate: 30%',
            'brightness: 70%'
        ];
        const map = L.map(this.mapElem).setView(mapCenterAndMarker, 16);

        L.Icon.Default.prototype.options.imagePath = "/Resources/Public/Images/Leaflet/";

        L.tileLayer.colorFilter('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            filter: window.matchMedia('(prefers-color-scheme: dark)').matches ? tileFilter : null
        }).addTo(map);

        L.marker(
            mapCenterAndMarker,
            {alt: 'REWE Bassum'}
        ).addTo(map)
        .bindPopup('REWE Bassum')
        .openPopup();
    }

    initGMaps() {
        this.mapElem.role = "application";
        
        const mapCenterAndMarker = {
            lat: parseFloat(this.mapElem.dataset.omeMaplat),
            lng: parseFloat(this.mapElem.dataset.omeMaplong)
        };
        const map = new google.maps.Map(this.mapElem, {
            zoom: 16,
            center: mapCenterAndMarker
        });

        google.maps.Marker({
            position: mapCenterAndMarker,
            map: map
        });
    }
}

EventHandler.one(document, 'DOMContentLoaded', () => {
    for (const mapElem of SelectorEngine.find('.ome-map')) {
        new MapGen(mapElem);
    }
});

export default MapGen;
